<template>
  <div class="wrapper">
    <side-bar type="sidebar" :sidebar-links="$sidebar.sidebarLinks">
      <user-menu></user-menu>
    </side-bar>

    <div class="main-panel" :class="viewClass">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"></dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>

<script>

import TopNavbar from '@/components/TravellerLayout/TopNavbar.vue'
import ContentFooter from '@/components/TravellerLayout/ContentFooter.vue'
import DashboardContent from './Content.vue'
import UserMenu from '@/components/TravellerLayout/UserMenu.vue'
import SideBar from '@/components/TravellerLayout/SideBar.vue'

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    UserMenu,
    SideBar
  },
  computed: {
    viewClass(){
      var vclass = this.$store.state.path;
      if(vclass) vclass = vclass.replaceAll("/","-")
      return vclass;
    }

  },
  methods: {
    toggleSidebar () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    }
  }
}

</script>
